/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorx_Undelivered_FixInputs */

const en_sorx_undelivered_fix = /** @type {(inputs: Sorx_Undelivered_FixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set up channels`)
};

const id_sorx_undelivered_fix = /** @type {(inputs: Sorx_Undelivered_FixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atur kanal`)
};

/**
* | output |
* | --- |
* | "Set up channels" |
*
* @param {Sorx_Undelivered_FixInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const sorx_undelivered_fix = /** @type {((inputs?: Sorx_Undelivered_FixInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorx_Undelivered_FixInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sorx_undelivered_fix(inputs)
	return en_sorx_undelivered_fix(inputs)
});